import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { IconLink, theme, useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

export const RightIcon = ({ onPress }: { readonly onPress: () => void }) => {
  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  return (
    <IconLink
      testID="location.search-bar.close-button"
      name="IconClose"
      style={
        Platform.OS === 'web' ? match([styles.iconXS, styles.icon]) : undefined
      }
      accessibilityLabel={t('general.close')}
      accessibilityHint={t('home.navigation')}
      onPress={onPress}
    />
  );
};

const styles = StyleSheet.create({
  icon: {
    marginLeft: theme.spacing.medium,
  },
  iconXS: {
    marginRight: theme.spacing.medium,
  },
});
